import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('RecalculatingView').create(({ theme }) => ({
  root: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowY: 'scroll',
    position: 'relative',
    gap: '12px',
    padding: '0px 5vw',
    paddingBottom: '2vh',

    h1: {
      color: theme.colors.text.primary,
    },
  },
}))
